import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import Lock from 'assets/images/unlock.svg';
import apiFetch from 'utils/apiFetch';
import Switch from '@material-ui/core/Switch';
import AutocompleteInput from 'components/AutocompleteInput';
import {
  FormWrapper, Image, InputName, InputDescription, BtnSubmit, IconTitle, TagsWrapper, TagLabel, TimeLife, TagContainer, PrivateTable, Wrapper,
} from '../../../components/CreationThinkSeed/components/styles';

function ThemeTableEdit(props) {
  const {
    tables, match: { params: { id } }, literals, updateThemeTable,
    setBreadcrumb, resetAll, history,
  } = props;
  const data = _.find(tables, { id: parseInt(id, 10) });

  if (!data) return null;

  let timeDiff = Math.max(0, data.limit_date - moment().unix());

  const daysDiff = timeDiff > 0 ? Math.floor(timeDiff / (24 * 3600)) : 0;
  timeDiff %= 24 * 3600;
  const hoursDiff = timeDiff > 0 ? Math.floor(timeDiff / 3600) : 0;
  timeDiff %= 3600;
  const minutesDiff = timeDiff > 0 ? Math.floor(timeDiff / 60) : 0;
  timeDiff %= 60;
  const secondsDiff = timeDiff;

  const [name, setName] = useState(data.name);
  const [description, setDescription] = useState(data.description);
  const [tags, setTags] = useState(_.map(_.filter(data.related_elements, { type: 'tag' }), tag => tag.name));
  const [image, setImage] = useState(data.image);
  const [changeDay, setChangeDay] = useState(false);
  const [day, setDay] = useState(daysDiff);
  const [hour, setHour] = useState(hoursDiff);
  const [minute, setMinute] = useState(minutesDiff);
  const [seconds, setSeconds] = useState(secondsDiff);
  const [enableSwitch, setEnableSwitch] = useState(data.is_private);
  const [error, setError] = useState(null);
  const [unloadedImage, setUnloadedImage] = useState(null);
  const [uploadingImage, setUploadingImage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [status, setStatus] = useState(false);

  const handleBackArrow = () => {
    history.push(`/theme-table/${id}`);
  };

  const printBreadcrumb = () => {
    const breadcrumb = [
      {
        type: 'back',
        onClick: handleBackArrow,
      },
      {
        color: '#ffffff',
        text: literals.editTable,
      },
    ];

    setBreadcrumb(breadcrumb.slice());
    resetAll();
  };

  const printImage = () => {
    const button = (
      <div className='upload'>
        <img src={image} alt='upload' />
        {literals.pressToUploadImage}
      </div>);
    const color = 'blue';
    return (
      <Image
        image={image}
        htmlFor='document_file'
        color={color}
      >
        {
          !image && !uploadingImage && button
        }
        {
          !image && uploadingImage && literals.uploading
        }
        {image && (
          <img className='uploaded' src={image} alt='' />
        )}
      </Image>
    );
  };

  const uploadImage = (dataFile, nameFile) => {
    const params = {
      data: dataFile,
      name: nameFile,
    };
    setUploadingImage(true);
    apiFetch('POST', { endPoint: 'upload-file' }, params)
      .then((response) => {
        let newError = error;
        if (error === literals.errorUploadingImage) {
          newError = null;
        }
        setImage(response.url);
        setUploadingImage(false);
        setStatus(true);
        setError(newError);
      })
      .catch(() => {
        let newError = error;
        if (error === literals.errorUploadingImage) {
          newError = null;
        }
        setImage('');
        setUploadingImage(false);
        setError(newError);
      });
  };

  const handleFileUpload = (event) => {
    if (event.target.files[0] !== undefined) {
      const file = event.target.files[0];

      const reader = new FileReader();
      reader.onloadend = () => {
        uploadImage(reader.result, file.name);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleChangeName = (event) => {
    const { value } = event.target;
    setStatus(true);
    setName(value);
  };

  const handleChangeDescription = (event) => {
    const { value } = event.target;
    setStatus(true);
    setDescription(value);
  };

  const handleTag = (tag) => {
    if (!tags.includes(tag.name)) {
      tags.push(tag.name);
      setStatus(true);
      setTags([...tags]);
    }
  };

  const handleChangeEnabled = () => {
    setStatus(true);
    setEnableSwitch(!enableSwitch);
  };

  const handleRemoveTag = (event) => {
    const tag = event.currentTarget.getAttribute('data-tag');
    _.remove(tags, t => t === tag);
    setTags([...tags]);
    setStatus(true);
  };

  const setTimeLife = (event) => {
    let value = event.currentTarget.value ? parseInt(event.currentTarget.value, 10) : 0;

    if (Number.isNaN(value) || value < 0) {
      value = 0;
    }
    setStatus(true);

    const attrTime = event.currentTarget.getAttribute('attr-time');
    setChangeDay(true);
    switch (attrTime) {
      case 'day':
        setDay(value);
        break;
      case 'hour':
        setHour(value);
        break;
      case 'minute':
        setMinute(value);
        break;
      case 'seconds':
        setSeconds(value);
        break;
      default:
        break;
    }
  };

  const printTags = () => {
    const tagList = _.map(tags, (tag, index) => (<TagLabel key={index} data-tag={tag} onClick={handleRemoveTag}>{tag}</TagLabel>));

    if (tags.length > 0) {
      return (
        <TagContainer>
          {tagList}
        </TagContainer>
      );
    }
    return <React.Fragment />;
  };

  const submit = () => {
    if (status && !isLoading) {
      const params = {
        id,
        name,
        description,
        image,
        tags: tags.join('%_%'),
        private: +enableSwitch,
        timelimit: moment().unix() + (day * 86400) + (hour * 1440) + (minute * 60) + seconds,
      };
      setIsLoading(true);
      apiFetch('POST', { endPoint: 'think-seed' }, params)
        .then((response) => {
          updateThemeTable(response);
          setIsLoading(true);
          history.push(`/theme-table/${id}`);
        })
        .catch((errorResponse) => {
          console.error(errorResponse);
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    printBreadcrumb();
  }, []);

  return (
    <Wrapper>
      <FormWrapper>
        <div className='title_card_wrapper'>
          {data.more_info && data.more_info.icon_title && (
            <IconTitle className='title_card_icon' icon={data.more_info.icon_title} />
          )}
        </div>
        {
          printImage()
        }
        <input
          type='file'
          id='document_file'
          name='document_file'
          style={{ display: 'none' }}
          onChange={handleFileUpload}
          accept='image/png, image/jpeg'
        />
        <InputName
          value={name}
          placeholder={literals.titleName}
          onChange={handleChangeName}
        />
        <InputDescription
          value={description}
          placeholder={literals.description}
          onChange={handleChangeDescription}
        />
        <TagsWrapper>
          <AutocompleteInput
            canCreateNew
            type='tag'
            placeholder={literals.tags}
            selectedOptions={[]}
            onSelectOption={handleTag}
            onCreateOption={handleTag}
          />
        </TagsWrapper>
        {printTags()}
        <TimeLife>
          <div>
            {literals.timeLife}
          </div>
          <div className='time_life'>
            <input type='text' maxLength='2' attr-time='day' value={day} onChange={setTimeLife} placeholder='00' />
            {' days : '}
            <input type='text' maxLength='2' attr-time='hour' value={hour} onChange={setTimeLife} placeholder='00' />
            {' hours : '}
            <input type='text' maxLength='2' attr-time='minute' value={minute} onChange={setTimeLife} placeholder='00' />
            {' min : '}
            <input type='text' maxLength='2' attr-time='seconds' value={seconds} onChange={setTimeLife} placeholder='00' />
            {' sec'}
          </div>
        </TimeLife>
        <PrivateTable>
          <div>
            {literals.privateTable}
          </div>
          <div>
            <img src={Lock} alt='' />
            <Switch
              checked={enableSwitch}
              size='small'
              onChange={handleChangeEnabled}
              name='check_enabled'
              color='primary'
            />
            {literals.onlyInvited}
          </div>
        </PrivateTable>
        <BtnSubmit status={status} onClick={submit}>
          {isLoading ? literals.saving : literals.accept}
        </BtnSubmit>
      </FormWrapper>
    </Wrapper>
  );
}

ThemeTableEdit.propTypes = {
  match: PropTypes.object.isRequired,
  tables: PropTypes.array.isRequired,
  updateThemeTable: PropTypes.func.isRequired,
  setBreadcrumb: PropTypes.func.isRequired,
  resetAll: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
};

export default ThemeTableEdit;



// WEBPACK FOOTER //
// ./src/routes/ThemeTableEdit/components/index.jsx